module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/id/3-7888b9fa0631423a39b64afe620e20f6.jpg";